module.exports = __webpack_public_path__ + "img/altitude-resort-1.f4cc4859.jpg";